<template lang="pug">
#drawer-menu-busca-finca
    el-drawer(
        :title='$t("mensagens.menuMapa.area")',
        direction='rtl',
        :class='menuMaior ? "drawer-menu-busca-finca" : "drawer-menu-busca-finca menor"',
        :visible.sync='show',
        :before-close='closeDrawerMenuBuscaFinca',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247'
    )
        template(slot='title', slot-scope='scope')
            div(:class='menuMaior ? "titulo-drawer" : "titulo-drawer-menor"')
                i.mdi.mdi-magnify
                | {{ title }}

        .card-container
            el-menu(
                :default-active='defaultActive',
                :class='menuMaior ? "" : "menu-menor"',
                :collapse='false'
            )
                el-menu-item
                    el-select(
                        v-model='departamentoSelecionado',
                        :loading='departamento.loading',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento")',
                        @change='listarDistritos',
                        clearable,
                        value-key='id'
                    )
                        el-option(
                            v-for='item in departamento.lista',
                            :key='item.id',
                            :label='item.nome',
                            :value='item'
                        )

                el-menu-item
                    el-select(
                        :disabled='!departamentoSelecionado',
                        :loading='distrito.loading',
                        v-model='distritoSelecionado',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.dist")',
                        clearable,
                        value-key='id'
                    )
                        el-option(
                            v-for='item in distrito.lista',
                            :key='item.id',
                            :label='item.nome',
                            :value='item'
                        )

                el-menu-item.flex-buttons
                    el-input(
                        :clearable='true',
                        prefix-icon='el-icon-search',
                        type='text',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.pesquisaPlaceholderPY")',
                        maxLength='10',
                        style='width: 100%; font-size: 12px',
                        v-model='fincaOuPadron'
                    )
                    el-button(
                        :disabled='!podeRealizarBusca',
                        type='primary',
                        @click='buscarTerritorioPorFincaOrPadron',
                        size='mini',
                        icon='el-icon-plus'
                    )
</template>

<script>
import store from '@/store';
import TerritorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import L from 'leaflet';
import Mapa from '@/utils/mapa/mapa.service';

export default {
    name: 'DrawerMenuBuscaFinca',

    props: {
        show: {
            type: Boolean,
            default: false
        },
        menuMaior: {
            type: Boolean,
            default: false
        },
        mapa: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            title: this.$t('mensagens.menuMapa.pesquisar'),
            defaultActive: '',
            fincaOuPadron: '',
            departamentoSelecionado: null,
            distritoSelecionado: null,
            departamento: {
                lista: [],
                loading: false
            },
            distrito: {
                lista: [],
                loading: false
            }
        };
    },

    computed: {
        podeRealizarBusca() {
            return (
                this.departamentoSelecionado &&
                this.distritoSelecionado &&
                this.fincaOuPadron
            );
        }
    },

    async mounted() {
        await this.listarDepartamentos();
    },

    methods: {
        closeDrawerMenuBuscaFinca() {
            this.$emit('closeDrawerMenuBuscaFinca');
        },

        ordenarPorNome(a, b) {
            return a.nome.localeCompare(b.nome, 'pt-BR', {
                sensitivity: 'base'
            });
        },

        async listarDepartamentos() {
            this.departamento.loading = true;

            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();
                this.departamento.lista = data
                    .map(item => ({
                        id: item.id,
                        nome: item.nome,
                        codigo: item.codigo
                    }))
                    .sort(this.ordenarPorNome);
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            } finally {
                this.departamento.loading = false;
            }
        },

        async listarDistritos() {
            this.distrito.loading = true;
            this.distritoSelecionado = null;
            this.distrito.lista = [];

            if (!this.departamentoSelecionado?.id) {
                this.distrito.loading = false;
                return;
            }

            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.departamentoSelecionado.id
                    );

                if (!Array.isArray(data)) {
                    throw new Error('Resposta inválida da API');
                }

                this.distrito.lista = data
                    .map(item => ({
                        id: item.id,
                        nome: item.nome,
                        codigo: item.codigo.replace(/[^\d]/g, '')
                    }))
                    .sort(this.ordenarPorNome);
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
                this.distrito.lista = [];
            } finally {
                this.distrito.loading = false;
            }
        },

        clearLayers() {
            if (this.geometria) {
                this.mapa.removeLayer(this.geometria);
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },

        mostrarTerritorioNoMapaPY(dadosOutputApi, valorPesquisado) {
            this.clearLayers();

            const bounds = L.latLngBounds();

            dadosOutputApi.forEach(geom => {
                const geometriaLayer = Mapa.criarGeoJSON(
                    geom.geometria,
                    mapaEstilos.Geometria.imovelRuralCandidato
                );

                geometriaLayer.identificadorGeometria = valorPesquisado;
                this.mapa.addLayer(geometriaLayer);
                bounds.extend(geometriaLayer.getBounds());
            });

            if (bounds.isValid()) {
                this.mapa.fitBounds(bounds, { maxZoom: 14 });
            }
        },

        async buscarTerritorioPorFincaOrPadron() {
            try {
                const response =
                    await TerritorioService.buscarTerritorioPorFincaOrPadron(
                        this.fincaOuPadron,
                        this.departamentoSelecionado.codigo,
                        this.distritoSelecionado.codigo
                    );

                const data = response?.data?.finca?.data;
                if (Array.isArray(data)) {
                    await this.mostrarTerritorioNoMapaPY(
                        data,
                        this.fincaOuPadron
                    );
                }
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.menuMapa.notificacoes.naoFoiPossivelConsultarCarParaguay'
                    )
                });
            }
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-busca-finca {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-menu-busca-finca {
        z-index: 500 !important;
        position: absolute;
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .titulo-drawer {
        font-size: 17px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-drawer-menor {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary);
    }

    .el-drawer__header {
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .card-container {
        height: 100%;
        background-color: var(--white);
        overflow-y: auto;
        overflow-x: hidden;

        .el-menu {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;
        }
    }

    .el-menu-item:hover,
    .el-menu-item:focus {
        background-color: unset !important;
    }

    .el-select {
        width: 100% !important;
    }

    .flex-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        button {
            width: 44px;
            height: 39px;
            display: flex;
            justify-content: center;
            align-items: center;

            i {
                margin: 0 !important;
                color: white;
                font-size: 12px !important;
            }
        }
    }
}
</style>
